export default __webpack_public_path__ + "static/step6-3032662a6fc8e2aa07b7ef0be0d5d2f6.svg";